/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { FinalizeGiftSendResponse, FinalizeGiftSendVars } from '../openapi-types.gen.js';

export type { FinalizeGiftSendResponse, FinalizeGiftSendVars } from '../openapi-types.gen.js';

export const useFinalizeGiftSend = createMutationHook<FinalizeGiftSendVars, FinalizeGiftSendResponse, unknown>({
  specName: 'useFinalizeGiftSend',
  path: '/v1/gifts/send/finalize',
  method: 'POST',
  resolveUrl: (vars: FinalizeGiftSendVars) => `/v1/gifts/send/finalize`,
  buildBody: (vars: FinalizeGiftSendVars) => ({ giftPda: vars.giftPda, signature: vars.signature }),
  parseResponse: (raw: unknown): FinalizeGiftSendResponse => raw as FinalizeGiftSendResponse,
  
  
  
});
